import React, { useState } from 'react';
import styled from 'styled-components';

interface BackupCodeInputProps {
  onVerify: (code: string) => void;
  loading: boolean;
}

// ✅ STYLED COMPONENTS
const Container = styled.div`
  margin: 24px 0;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-size: 16px;
  color: #2c3e50;
  transition: border-color 0.2s;
  margin-bottom: 16px;
  
  &:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }
  
  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }
  
  &::placeholder {
    color: #bdc3c7;
  }
`;

const VerifyButton = styled.button<{ disabled: boolean }>`
  background: ${props => props.disabled ? '#bdc3c7' : '#27ae60'};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  width: 100%;
  
  &:hover:not(:disabled) {
    background: #229954;
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.7;
  }
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const InfoText = styled.p`
  color: #7f8c8d;
  font-size: 14px;
  text-align: center;
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const BackupCodeInput: React.FC<BackupCodeInputProps> = ({
  onVerify,
  loading
}) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (code.trim()) {
      onVerify(code.trim());
    }
  };

  return (
    <Container>
      <InfoText>
        Use um código de backup se não conseguir acessar seu authenticator
      </InfoText>
      
      <form onSubmit={handleSubmit}>
        <Input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Digite seu código de backup"
          disabled={loading}
          autoFocus
        />
        
        <VerifyButton 
          type="submit" 
          disabled={loading || !code.trim()}
        >
          {loading ? (
            <>
              <LoadingSpinner />
              Verificando...
            </>
          ) : (
            'Usar Código de Backup'
          )}
        </VerifyButton>
      </form>
    </Container>
  );
};